import { createSlice } from "@reduxjs/toolkit";
import { dataHookFactory, DefaultFailureAction } from "../common/reducers/utilities";
import { ensureArray } from "../common/utils/arrayUtilities";
import { logout } from "../common/reducers/initContext";

const prepareArray = data => ensureArray(data).map(member => ({
    ...member,
    name: member.preferredname ?? member.firstname,
}))

export const contactSlice = createSlice({
    name: 'contacts',
    initialState: {
        data: []
    },
    reducers: {
        set: (state, action) => {
            state.data = prepareArray(action.payload);
        },
        addOrUpdate: (state, action) => {
            prepareArray(action.payload).forEach(c => {
                let idx = state.data.findIndex(c2 => c.id === c2.id);
                if (idx >= 0) {
                    state.data.splice(idx, 1, c);
                } else {
                    state.data.push(c);
                }
            })
        },
        remove: (state, action) => {
            state.data = state.data.filter(c => ensureArray(action.payload).every(toDelete => toDelete.id !== c.id))

        },
        extraReducers: builder => {
            builder.addCase(logout, () => contactSlice.getInitialState());
        }
    }
});

const visualizeFailure = verb => DefaultFailureAction(verb, 'contact_one');
const fetchContacts = network => network.get('/api/v2/contacts', contactSlice.actions.set, visualizeFailure('get'));

const selectContacts = state => state.contacts.data;

const listen = {
    contactCreated: (contact, { dispatch }) => dispatch(contactSlice.actions.addOrUpdate(contact)),
    contactUpdated: (contact, { dispatch }) => dispatch(contactSlice.actions.addOrUpdate(contact)),
    contactRemoved: (contact, { dispatch }) => dispatch(contactSlice.actions.remove(contact))
}
const initContacts = { run: fetchContacts, listen, immortal: true }
export const [useContacts] = dataHookFactory(selectContacts, initContacts);

const reducer = { name: contactSlice.name, reducer: contactSlice.reducer }
export default reducer;